export type ScoreSeverity = 'success' | 'warn' | 'danger';

export function getScoreSeverity (score: number | null | undefined): ScoreSeverity | undefined {
  if (score === null || score === undefined) { return undefined; }
  const pct = score * 100;
  if (pct > 90) { return 'success'; }
  if (pct > 50) { return 'warn'; }
  return 'danger';
}

export function formatScorePercent (score: number | null | undefined): string | null {
  if (score === null || score === undefined) { return null; }
  return `${Math.trunc(score * 100)}`;
}

interface Scorable {
  score: number | null | undefined;
}

export function computeAverageScore (items: Scorable[]): number | null {
  const scores = items
    .filter(s => s.score !== null && s.score !== undefined)
    .map(s => s.score as number);
  if (!scores.length) { return null; }
  return scores.reduce((sum, s) => sum + s, 0) / scores.length;
}
